import type { LinkAttachment as LinkAttachmentType } from '@/states/attachment'
import { css } from '@emotion/react'
import LinkCard from '../Post/PostTargetCard/LinkCard'
import Attachment, { AttachmentProps } from './Attachment'

export interface LinkAttachmentProps extends AttachmentProps {
	data: LinkAttachmentType
	onDelete?: () => void
}

export default function LinkAttachment({ data, onDelete, ...props }: LinkAttachmentProps) {
	return (
		<Attachment
			onClose={onDelete}
			css={css`
				max-width: 500px;
				margin-right: 9px;
			`}
			{...props}
		>
			<LinkCard data={data.linkInfo} css={css``} />
		</Attachment>
	)
}
